import { $fetch } from '@/plugins/Fetch'
/**
 * 工作台 相关接口
 * amujoe
 */
export default {
  methods: {
    // 客户的养护卡
    customerCardListApi (query) {
      return $fetch('upkeep/customer_upkeep', {
        method: 'GET',
        body: query,
      })
    },
    // 工作台 - 预约列表
    workbenchReserve (query) {
      return $fetch('new_order/reserve_list', {
        method: 'GET',
        body: query,
      })
    },
    // 工作台 - 核销码详情
    checkDetail (query) {
      return $fetch('new_order/detail', {
        method: 'GET',
        body: query,
      })
    },
    // 工作台 - 核销操作
    workbenchCheck (data) {
      return $fetch('new_order/write_off', {
        method: 'POST',
        body: data,
      })
    },
    // 工作台 - 核销列表
    checkList (data) {
      return $fetch('new_order/write_off_list', {
        method: 'POST',
        body: data,
      })
    },

    // 平台券核销详情
    searchPlatCoupon (query) {
      return $fetch('marketing/hub_coupon/detail', {
        method: 'POST',
        body: query,
      })
    },
    // 平台券核销详情
    PlatCouponOff (query) {
      return $fetch('marketing/hub_coupon/write', {
        method: 'POST',
        body: query,
      })
    },
    // 卡券核销搜索 marketing/write/{checkCode}
    searchCord (query) {
      return $fetch(`marketing/write/${query}`, {
        method: 'GET',
      })
    },
    // 卡券核销操作
    writeOffCard (query) {
      return $fetch(`marketing/write/${query.checkCode}`, {
        method: 'POST',
        body: query,
      })
    },
    // 卡券核销列表 marketing/write
    cardOffList (query) {
      return $fetch('marketing/write', {
        body: query,
      })
    },
    // 团购核销列表
    getGroupPurchaseApi (query) {
      return $fetch('tuan_gou/coupon/list', {
        body: query,
      })
    },
    // 核销团购券
    getGroupPurchaseCouponApi (query) {
      return $fetch('tuan_gou/coupon/write_off', {
        method: 'POST',
        body: query,
      })
    },
    // 验证核销码
    getGroupPurchaseVerifyApi (query) {
      return $fetch('tuan_gou/coupon/verify', {
        method: 'POST',
        body: query,
      })
    },
    // 养护卡核销列表
    getCardManagementListApi (params) {
      return $fetch('upkeep/validate_record', {
        method: 'GET',
        body: params,
      })
    },
    // 平台券核销列表
    getPlatCouponOffListApi (params) {
      return $fetch('marketing/hub_coupon/write_list', {
        method: 'POST',
        body: params,
      })
    },
    // 养护卡核销信息
    getCardManagementInfoApi (params) {
      return $fetch('upkeep/validate_info_new', {
        method: 'GET',
        body: params,
      })
    },
    // 次卡确认核销
    selfApi (params) {
      return $fetch('upkeep/validate_new', {
        method: 'POST',
        body: params,
      })
    },
    // 养护卡确认核销
    getCardManagementConfirmApi (params) {
      return $fetch('upkeep/validate_new', {
        method: 'POST',
        body: params,
      })
    },
    // 养护卡查看详情
    getCardManagementDetailApi (params) {
      return $fetch('upkeep/detail', {
        method: 'GET',
        body: params,
      })
    },
    // 养护卡查看详情
    getCardManagementDetailTwoApi (params) {
      return $fetch('upkeep/detail_iso', {
        method: 'GET',
        body: params,
      })
    },
    // 获取客户车辆列表 /v1/customer/vehicle/list
    getCustomerCarApi (params) {
      return $fetch('customer/vehicle/list', {
        method: 'GET',
        body: params,
      })
    },
    // 获取加入平台信息 workbench/storeDetail
    storePlatformDetailApi (params) {
      return $fetch('workbench/storeDetail', {
        method: 'GET',
        body: params,
      })
    },
    // 获取银行卡信息
    getBandCardApi (params) {
      return $fetch('workbench/cardnoGet', {
        method: 'POST',
        body: params,
      })
    },
    // 加入平台 workbench/storeApply
    jionPlatformApi (params) {
      return $fetch('workbench/storeApply', {
        method: 'POST',
        body: params,
      })
    },
    // 退出平台 workbench/storeOut
    outPlatformApi (params) {
      return $fetch('workbench/storeOut', {
        method: 'GET',
        body: params,
      })
    },

    workbenchUpkeepReserve (params) {
      return $fetch('upkeep/reserve_list', {
        method: 'POST',
        body: params,
      })
    },
    // 天猫平台信息
    TmallPlatInfoApi (params) {
      return $fetch('workbench/store_apply_o2o_info', {
        method: 'POST',
        body: params,
      })
    },
    // 加入天猫平台
    JoinTmallPlatApi (params) {
      return $fetch('workbench/store_apply_o2o', {
        method: 'POST',
        body: params,
      })
    },
    // 保存平台
    saveTmallPlatApi (params) {
      return $fetch('workbench/store_save', {
        method: 'POST',
        body: params,
      })
    },
    // 天猫订单详情
    TMallOrderDetailApi (params) {
      return $fetch('new_order/tmall_detail', {
        method: 'POST',
        body: params,
      })
    },
    // 天猫订单核销
    TmallWriteOffApi (params) {
      return $fetch('new_order/tmall_write_off', {
        method: 'POST',
        body: params,
      })
    },
    // 京东订单详情
    JDOrderDetailApi (params) {
      return $fetch('new_order/jd_detail', {
        method: 'POST',
        body: params,
      })
    },
    // 京东订单核销
    JDWriteOffApi (params) {
      return $fetch('new_order/jd_write_off', {
        method: 'POST',
        body: params,
      })
    },
    // 京东核销码验证正确
    JDOrderCheck (params) {
      return $fetch('new_order/check_code', {
        method: 'POST',
        body: params,
      })
    },
    // 加入平台状态
    JoinStatusApi (params) {
      return $fetch('workbench/is_store_join', {
        method: 'GET',
        body: params,
      })
    },
    // 公共 - 省市区列表1
    fetchRegions (query) {
      return $fetch('common/amap_regions', { query })
    },
    // o2o 抖音，官方商城核销
    o2oWriteOff (params) {
      return $fetch('new_order/o2o_write_off', {
        method: 'POST',
        body: params,
      })
    },
    // O2O 抖音，官方商城根据核销码获取订单详情
    o2oWriteOffInfo (params) {
      return $fetch('new_order/o2o_write_off_info', {
        method: 'POST',
        body: params,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/workbench.js